import React, { Component } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { Collaborator } from "../../Common/Icons";

export default class CollaboratorsListLink extends Component {
  render() {
    return (
      <SubMenuLink pathname="/collaborators" title="collaborators">
        <Collaborator className={"light-sub-menu-icon"} />
      </SubMenuLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/CollaboratorsListLink.js